import { useState, useLayoutEffect } from 'react';
import type { Theme } from '@mui/material';

import useUrlInfo from '../../utils/urls/useUrlInfo';
import buildTheme from './buildTheme';
import useAppConfig from 'canvas_states/config/useAppConfig';
import { fetchThemesByPid } from '../../utils/theme/fetchThemesByPid';
export interface UseBuildThemeHookProps {
  pid?: string;
  appName?: string;
}

export const useBuildTheme = ({ appName, pid }: UseBuildThemeHookProps) => {
  const [theme, setTheme] = useState<Theme>();

  useLayoutEffect(() => {
    const fetchTheme = async () => {
      let themeToUse = buildTheme();
      if (appName && pid) {
        const partnerThemes = await fetchThemesByPid(appName, pid);
        if (partnerThemes.length > 0) {
          themeToUse = buildTheme(partnerThemes);
        } else {
          console.error(`Missing partner theme for ${pid}. Using default theme`);
        }
      }

      setTheme(themeToUse);
    };
    fetchTheme().catch(console.error);
  }, [appName, pid]);

  return theme;
};

const useCurrentTheme = () => {
  const appName = useAppConfig().selectors.getThemeVertical();
  const { pid } = useUrlInfo().states;

  return useBuildTheme({ appName, pid });
};

export default useCurrentTheme;
